function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as l } from "../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as g } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as o } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import c from "../../packages/web-components/src/components/selection-box-group/selection-box-group.gator.scss.js";
import m from "../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import { generateRandomId as b, getElementId as y } from "../../utils/string-utils.js";
import "../selection-box/selection-box.gator.js";
import "../radio-group/radio-group.gator.js";
import "../checkbox-group/checkbox-group.gator.js";
import { TestableLitElement as x } from "../../utils/components/testable-lit-element/testable-lit-element.js";
import { ifDefined as d } from "../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { unsafeCSS as u } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var $ = Object.defineProperty,
  v = Object.getOwnPropertyDescriptor,
  i = function i(e, r, s, h) {
    for (var a = h > 1 ? void 0 : h ? v(r, s) : r, n = e.length - 1, p; n >= 0; n--) (p = e[n]) && (a = (h ? p(r, s, a) : p(a)) || a);
    return h && a && $(r, s, a), a;
  };
var t = /*#__PURE__*/function (_x) {
  function t() {
    var _this;
    _classCallCheck(this, t);
    _this = _callSuper(this, t, arguments), _this.id = "", _this.options = [], _this.disabled = !1, _this.value = void 0, _this.label = "", _this.helpText = "", _this.type = "single-select", _this.hasError = !1, _this.errorMessage = "", _this._randomId = b();
    return _this;
  }
  _inherits(t, _x);
  return _createClass(t, [{
    key: "render",
    value: function render() {
      return l(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), this.isSingleSelect ? this.radioGroupMarkup : this.checkboxGroupMarkup);
    }
  }, {
    key: "elementId",
    get: function get() {
      return y(this.id, this._randomId);
    }
  }, {
    key: "radioGroupMarkup",
    get: function get() {
      return l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t<ngc-radio-group\n\t\t\t\tid=", "\n\t\t\t\tvalue=", "\n\t\t\t\t.disabled=", "\n\t\t\t\t.label=", "\n\t\t\t\thelp-text=", "\n\t\t\t\t?has-error=", "\n\t\t\t\terror-message=", "\n\t\t\t\t@change=", "\n\t\t\t\t.dataTestid=", ">\n\t\t\t\t", "\n\t\t\t</ngc-radio-group>\n\t\t"])), this.id, d(this.value), this.disabled, this.label, this.helpText, this.hasError, this.errorMessage, this.handleChange, this.dataTestid, this.optionsMarkup);
    }
  }, {
    key: "checkboxGroupMarkup",
    get: function get() {
      return l(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t<ngc-checkbox-group\n\t\t\t\tid=", "\n\t\t\t\tvalue=", "\n\t\t\t\t.disabled=", "\n\t\t\t\t.label=", "\n\t\t\t\thelp-text=", "\n\t\t\t\t?has-error=", "\n\t\t\t\terror-message=", "\n\t\t\t\t@change=", "\n\t\t\t\t.dataTestid=", ">\n\t\t\t\t", "\n\t\t\t</ngc-checkbox-group>\n\t\t"])), this.id, d(this.value), this.disabled, this.label, this.helpText, this.hasError, this.errorMessage, this.handleChange, this.dataTestid, this.optionsMarkup);
    }
  }, {
    key: "optionsMarkup",
    get: function get() {
      return l(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), this.options.length > 0 ? this.generatedRadiosFromOptionsProperty : l(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<slot></slot>"]))));
    }
  }, {
    key: "selectionBoxType",
    get: function get() {
      return this.isSingleSelect ? "radio" : "checkbox";
    }
  }, {
    key: "isSingleSelect",
    get: function get() {
      return this.type === "single-select";
    }
  }, {
    key: "generatedRadiosFromOptionsProperty",
    get: function get() {
      var _this2 = this;
      return this.options.map(function (e, r) {
        return l(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t<ngc-selection-box\n\t\t\t\ttitle-text=", "\n\t\t\t\tsubtitle-text=", "\n\t\t\t\tvalue=", "\n\t\t\t\t?selected=", "\n\t\t\t\t?disabled=", "\n\t\t\t\tbox-tabindex=", "\n\t\t\t\t?has-error=", "\n\t\t\t\ttype=", ">\n\t\t\t</ngc-selection-box>"])), e.title, e.subtitle, e.value, _this2.isItemSelected(e.value), _this2.disabled, _this2.getItemTabindex(r), _this2.hasError, _this2.selectionBoxType);
      });
    }
  }, {
    key: "optionElements",
    get: function get() {
      var _this$shadowRoot, _this$shadowRoot2;
      return this.options.length > 0 ? (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelectorAll("ngc-selection-box") : (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 || (_this$shadowRoot2 = _this$shadowRoot2.querySelector("slot")) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.assignedElements();
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(e) {
      var _this$value;
      return this.value ? this.isSingleSelect ? this.value === e : (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.split(";").includes(e) : !1;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var r = e;
      r.stopImmediatePropagation(), this.value = r.detail, this.dispatchEvent(new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: this.value
      }));
    }
  }, {
    key: "updated",
    value: function updated() {
      var _this$optionElements,
        _this3 = this;
      (_this$optionElements = this.optionElements) === null || _this$optionElements === void 0 || _this$optionElements.forEach(function (e, r) {
        var _s$getAttribute;
        var s = e;
        s.boxTabindex = _this3.getItemTabindex(r), s.type = _this3.selectionBoxType, s.disabled = _this3.disabled, s.selected = _this3.isItemSelected((_s$getAttribute = s.getAttribute("value")) !== null && _s$getAttribute !== void 0 ? _s$getAttribute : ""), s.hasError = _this3.hasError;
      });
    }
  }, {
    key: "getItemTabindex",
    value: function getItemTabindex(e) {
      return this.isSingleSelect ? e === 0 && !this.value ? 0 : -1 : 0;
    }
  }]);
}(x);
t.styles = [u(c), u(m)];
i([o({
  type: String
})], t.prototype, "id", 2);
i([o({
  type: Array
})], t.prototype, "options", 2);
i([o({
  type: Boolean
})], t.prototype, "disabled", 2);
i([o({
  type: String
})], t.prototype, "value", 2);
i([o({
  type: String
})], t.prototype, "label", 2);
i([o({
  type: String,
  attribute: "help-text"
})], t.prototype, "helpText", 2);
i([o({
  type: String
})], t.prototype, "type", 2);
i([o({
  type: Boolean,
  attribute: "has-error"
})], t.prototype, "hasError", 2);
i([o({
  type: String,
  attribute: "error-message"
})], t.prototype, "errorMessage", 2);
t = i([g("ngc-selection-box-group")], t);
export { t as NgcSelectionBoxGroup };